export default __webpack_public_path__ + "static/media/punchCard.51715200.svg";